module.exports = __webpack_public_path__ + "static/media/icon_cqd.15376a39.png";